import React from 'react';

import './styles.css';

function Loading() {
  return (
    <div className="loading">
      <h3 className="loading__text">Carregando...</h3>
    </div>
  );
}

export default Loading;